var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_27662",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 27662",
    transform: "translate(-47 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-\\u30B3\\u30D4\\u30FC",
    d: "M3.679,2A1.678,1.678,0,0,0,2,3.679V15.43H3.679V3.679H15.43V2ZM7.036,5.358A1.678,1.678,0,0,0,5.358,7.036V17.109a1.678,1.678,0,0,0,1.679,1.679H17.109a1.678,1.678,0,0,0,1.679-1.679V7.036a1.678,1.678,0,0,0-1.679-1.679Zm0,1.679H17.109V17.109H7.036Z",
    transform: "translate(46.6 14.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_16090",
    "data-name": "\\u9577\\u65B9\\u5F62 16090",
    width: 20,
    height: 20,
    transform: "translate(47 15)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.4567c5be120989b06813cd67256aa1c9.svg";
export { ForwardRef as ReactComponent };